'use strict';

namespace Core {

    class ScrollAndClickCtrl {

        private scrollTarget: string;
        private clickTarget: string;
        private activeClass: string;

        constructor(
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private scrollService: any,
        ) {
        }

        scrollAndClick(): void {
            this.scrollService.scrollTo(this.scrollTarget, { animate: true });

            this.$timeout(() => {
                const clickTarget = angular.element(this.clickTarget);

                if (!clickTarget.hasClass(this.activeClass)) {
                    clickTarget.click();
                }
            });
        }
    }

    angular
        .module('core')
        .directive('scrollAndClick', (): ng.IDirective => {

        return {
            bindToController: {
                scrollTarget: '@',
                clickTarget: '@',
                activeClass: '@'
            },
            controller: ScrollAndClickCtrl,
            controllerAs: 'scr',
            replace: false,
            restrict: 'E',
            scope: {},
            template: '<a href="" ng-click="scr.scrollAndClick()" ng-transclude></a>',
            transclude: true
        };
    });
}
